export default {
  methods: {
    getPicture(product) {
      if (product.pictures.length === 0) {
        return null;
      }

      const picture = product.pictures[0];

      return picture.href;
    },

    getThumbnail(product) {
      if (product.pictures.length === 0) {
        return null;
      }

      const picture = product.pictures[0];
      const thumbnail = _.find(picture.thumbnails, o => o.format === '120x120');

      if (thumbnail === undefined) {
        return null;
      }

      return thumbnail.href;
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/mixins/hasPictures.js